// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9d04dfb","453":"0098adef","667":"b0e95bb5","670":"607c74fa","937":"aff56e8a","946":"0455fd08","982":"c3ef28a7"}[chunkId] + ".chunk.js";
};